import emailjs from "emailjs-com";

const SERVICE_ID = "service_x2llhct";
const PUBLIC_KEY = "2Srr8nLyD_IRm7vVo";
const TEMPLATE_ID_OTP = "template_qx1m5mh";

export const sendReplayMail = async (name, email) => {
  if (!email || !name) {
    console.error(
      "Email Error: Missing required data (email, name)."
    );
    return { success: false, message: "Internal Error: Missing data." };
  }
  try {
    const templateParams = {
      to_name: name.split(" ")[0],
      to_email: email,
    };
    await emailjs.send(SERVICE_ID, TEMPLATE_ID_OTP, templateParams, PUBLIC_KEY);
    return { success: true, message: "Event Inquiry Has Been Submitted 🎉" };
  } catch (error) {
    console.error("Error sending OTP email:", error);
    return { success: false, message: "Event Inquiry Has Been Failed. Please try again." };
  }
};
